/*

Events triggered:

jrpForm:Submit - when the server responds after the form has been submiteed via AJAX

*/



(function ($) {

	var $forms;
	var formValues;
	var $header;
	var headerHeight;

	$(document).ready(function () {

		$forms = $('form.jrp-form');
		$header = $('#masthead');
		headerHeight = $header.outerHeight(true);

		// Debug icon
		$forms.find('.debug-fields-container .spanner').click(function() {
			$(this).parent('.debug-fields-container').addClass('debugging');
		});

		// On form submit
		$forms.submit(function (e, data) {

			var $this = $(this);
			
			// If JavaScript is disabled for debugging
			if ( $this.find('input[name=turn_off_javascript]').is(':checked') ) {
				return;
			}

			// If the ignore value is set


			e.preventDefault();

			// Reset values array
			formValues = [];

			// Set to currently submitting
			currentlySubmitting( $this );

			// Validate the form on client side
			var result = validateFormOnCS($this);

			// If form is valid
			if (result === true) {

				// Send to server for server-side validation
				sendFormToServer($this);

				// There are errors
			} else {

				finishedSubmitting( $this );

			}


		});

		// Remove messages once field has changed
		$forms.on('change', 'input, select, textarea, button', function () {

			var $this = $(this);
			var $form = $this.parents('form.jrp-form');

			// Return if form hasn't been validated yet
			if ( typeof $form.data('hasValidated') === 'undefined' ) {
				return;
			}

			var $fieldWrapper = $this.parents('div.field');

			// If not an official form field
			if ( $fieldWrapper.length === 0 ) {
				return;
			}

			var result = validateField($fieldWrapper);

			if (result === true) {
				clearFieldMessages($fieldWrapper);
			} else {
				addMessageToField($fieldWrapper, result[0].message);
			}

			// Remove submit messages if no more field messages
			var $invalidFields = $form.find('.field-invalid');

			if ( $invalidFields.length === 0 ) {
				clearSubmitMessages( $form );
			} else {
				addSubmitMessage( $form );
			}

		});

	});

	// Validate the form on the client side
	function validateFormOnCS($form) {

		$form.data('hasValidated', true);

		var $fieldWrappers = $form.find('div.field:not(.ignore-field)');

		var formErrors = [];

		$fieldWrappers.each(function (index) {

			var result = validateField($(this));

			if (result !== true) {
				formErrors.push(result);
			}

		});

		if (formErrors.length === 0) {
			clearSubmitMessages( $form );
			return true;
		}
		
		// Add submit message
		addSubmitMessage( $form );

		var $formMessages = $form.find('.field-invalid, .form-messages');

		maybeScroll( $formMessages.first() );

		return formErrors;

	}


	// Validate a single field
	function validateField($fieldWrapper) {

		var $field = $fieldWrapper.find('input, select, textarea, button');
		var fieldErrors = [];
		var output = true;

		// Remove unvalidated class
		$fieldWrapper.removeClass('field-unvalidated');

		// If no fields, continue
		if ($field.length === 0) {
			return;
		}

		// For debugging
		//return true;

		// Check for required values
		if ($field.attr('type') === 'checkbox') {
			
			var valFlag = false;
			var values = [];
			var name;
			
			$field.each(function () {

				var required = $(this).attr('required');

				if ( typeof required !== 'undefined' && required !== false && ! $(this).is(':checked') ) {
					fieldErrors.push({
						message: 'Please check the box.',
						field: $(this)
					});
				}

			});

		} else {
			var required = $field[0].hasAttribute('required');
			var value = $field.val();

			if (!value && required) {
				fieldErrors.push({
					message: 'Please enter a value.',
					field: $field
				});
			}


		}

		// Check for valid email address
		if ($field.attr('type') === 'email' && !validateEmail(value)) {
			fieldErrors.push({
				message: 'Please enter a valid email address.',
				field: $field
			});
		}

		// If there are field errors, add error messages
		if (fieldErrors.length > 0) {

			addMessageToField($fieldWrapper, fieldErrors[0].message);
			output = fieldErrors;

		} else {

			clearFieldMessages($fieldWrapper);

		}

		return output;

	}


	// Add a message to a field
	function addMessageToField($fieldWrapper, message, classes = 'alert') {

		var $fieldMessageBox = $fieldWrapper.find('.field-messages');

		$fieldWrapper.removeClass('field-valid').addClass('field-invalid');

		if ( message !== null ) {
			$fieldMessageBox.addClass(classes).html(message);
		}

	}


	// Clear field messages
	function clearFieldMessages($fieldWrapper) {

		var $fieldMessageBox = $fieldWrapper.find('.field-messages');

		$fieldWrapper.removeClass('field-invalid').addClass('field-valid');
		$fieldMessageBox.removeClass('alert success error').html('');


	}

	// Add message to the submit message wrapper
	function addSubmitMessage( $form, content = null ) {

		if ( content === null ) {
			content = '<div class="callout alert">There are errors within your form. Please review them and try again.</div>';
		}

		// Submit messages
		var $submitMessages = $form.find('.submit-messages-wrapper');

		$submitMessages.addClass('active').html(content);

	}

	// Clear the submit message wrapper
	function clearSubmitMessages( $form ) {

		// Submit messages
		var $submitMessages = $form.find('.submit-messages-wrapper');
		$submitMessages.removeClass('active');

	}


	// Set the current state to submitting
	function currentlySubmitting( $form ) {

		$form.addClass('submitting');

		// Disable submit button
		var $submitButton = $form.find('input[type=submit], button[type=submit]');
		$submitButton.attr('disabled', 'disabled');

		

		if ( $submitButton.prop('tagName') === 'INPUT' ) {
			$submitButton.data('button-text',$submitButton.val() );
			$submitButton.val('Submitting');
		} else {
			$submitButton.data('button-text',$submitButton.html() );
			$submitButton.html('Submitting');
		}

	}

	// Set the current state to finished submitting
	function finishedSubmitting( $form ) {

		$form.removeClass('submitting');

		// Disable submit button
		var $submitButton = $form.find('input[type=submit], button[type=submit]');
		$submitButton.removeAttr('disabled');

		if ( $submitButton.prop('tagName') === 'INPUT' ) {
			$submitButton.val( $submitButton.data('button-text') );
		} else {
			$submitButton.html( $submitButton.data('button-text') );
		}

	}


	// Reset form
	function resetForm( $form ) {

		$form.trigger('reset');

		var $fieldWrappers = $form.find('div.field:not(.ignore-field)');
		$fieldWrappers.removeClass('field-valid field-invalid').addClass('field-unvalidated');

	}


	// Validate the form on the server side
	function sendFormToServer($form) {

		$.ajax({
			type: "POST",
			dataType: "json",
			url: phpVars.ajaxurl,
			context: $form,
            data: {
                action: 'jrp_forms_proccess_form',
				formValues: $form.serialize(),
            },
            success: serverCallback
        });

	}


	// Callback for form AJAX submit
	function serverCallback( data ) {

		var $form = $(this);

		// Set to finished submitting
		finishedSubmitting( $form );

		// Show messages
		var $messageWrapper = $form.find('.form-messages-wrapper');
		if ( data.form_messages !== null ) {
			$messageWrapper.show().html( data.form_messages );
		} else {
			$messageWrapper.hide().html();
		}

		// Update form token
		$form.find('input#form_token').val(data.new_form_token);

		// Submit messages
		var $submitMessages = $form.find('.submit-messages-wrapper');
		if ( data.submit_messages ) {
			addSubmitMessage( $form, data.submit_messages);
		} else {
			clearSubmitMessages( $form );
		}
		
		// Update field messages
		if ( typeof data.fields === 'object' ) {

			for( var i = 0; i < data.fields.length; i++ ) {

				var field = data.fields[i];
				var $fieldWrapper = $( '#' + field.id );

				if ( field.valid === true ) {
					clearFieldMessages( $fieldWrapper );
				} else if ( field.valid === false )  {

					var message = null;
					var type = null;

					if ( field.messages.length > 0 ) {
						message = field.messages[0];
					}
					
					addMessageToField( $fieldWrapper, message );
				}

			}
		}

		// Trigger event
		$(document).trigger( 'jrpForm:Submit', [
			$form, data
		] );

		if ( data.type === 'valid' ) {

			resetForm( $form );

			// Redirect afte submit
			if ( data.redirect ) {
				window.location.href = data.redirect;
			} else if ( data.hide_after_submit === true ) {
				$form.addClass('hide-after-submit');
			}

			// If form is in a popup, close the popup after a delay
			if ( $form.parent('.jrp_form_popup').length == 1 ) {

				setTimeout(() => {
					$.magnificPopup.close();
				}, 1500);
				
			}

		} else if ( data.type === 'invalid' ) {

			// Scroll to first error
			maybeScroll( $form.find('.field-invalid, .form-messages').first() );

		}

	}



	// Smooth scroll to element if it is not in view
	function maybeScroll($el) {

		// If in view, don't scroll
		if (isInView($el)) {
			return;
		}

		var offset = 100;

		// Account for fixed #masthead
		if ( $header.css('position') === 'fixed' ) {
			offset += headerHeight;
		}

		// Account for WP top bar
		if ( $('body').hasClass('admin-bar') ) {
			offset += 32;
		}

		// Scroll to top of page
		$('html, body').animate({
			scrollTop: $el.offset().top - offset
		}, 1000);

	}

	// Checks to see if element is in viewport
	function isInView($el) {

		var top_of_element = $el.offset().top;
		var bottom_of_element = $el.offset().top + $el.outerHeight();
		var bottom_of_screen = $(window).scrollTop() + window.innerHeight;
		var top_of_screen = $(window).scrollTop();

		// Is it in view
		if ((bottom_of_screen > bottom_of_element) && (top_of_screen < top_of_element)) {
			return true;
		}

		return false;

	}

	// Validate email address
	function validateEmail(email) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}


})(jQuery);